import { render } from "./AdminOrganisations.vue?vue&type=template&id=a6585468"
import script from "./AdminOrganisations.vue?vue&type=script&lang=js"
export * from "./AdminOrganisations.vue?vue&type=script&lang=js"

import "./AdminOrganisations.vue?vue&type=style&index=0&id=a6585468&lang=css"

import exportComponent from "/home/pzborow/works/gunb/rwdzold/dev/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__